import CvVideoCard from '@authentication/components/CvVideo';
import useUser from '@authentication/hooks/useUser';
import React from 'react';

function CvVideoRecordPage() {
  const { setPageTitle } = useUser();
  React.useEffect(() => {
    setPageTitle('Enregistrez votre CV Vidéo');
  }, []);
  return <CvVideoCard />;
}

export default CvVideoRecordPage;
